import { helper } from "@ember/component/helper";

export function constantToSentenceCase([value] /* , hash*/) {
  let array = `${value}`.split("_").map((string) => string.toLowerCase());

  return array[0].charAt(0).toUpperCase() + array.join(" ").substring(1);
}

export default helper(constantToSentenceCase);
